import { useCallback } from "react";
import { useApi } from "../../../hooks/useApi";
import { urlReplacer } from "../../../utils";
import { ApiRoutes } from "../../../constants/apiRoutes";
import { IDegreeWithAcademicBackEndModel } from "../../academic/types";

export default function () {
  const { request } = useApi();
  return {
    fetchAllWithAcademic: useCallback(
      async (id): Promise<{ data: IDegreeWithAcademicBackEndModel[] }> => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.DEGREE_WITH_ACADEMIC, { id })}`,
        });
      },
      [request],
    ),

    fetchAllFilteredByAcademics: useCallback(
      async (id) => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.DEGREE_FILTERED_BY_ACADEMICS, { id })}`,
        });
      },
      [request],
    ),

    fetchAll: useCallback(async () => {
      return request({
        method: "GET",
        url: `${ApiRoutes.DEGREES}`,
      });
    }, [request]),

    fetchAllContainingAcademic: useCallback(async () => {
      return request({
        method: "GET",
        url: `${ApiRoutes.DEGREE_CONTAINING_ACADEMIC}`,
      });
    }, [request]),

    fetchOne: useCallback(
      async (id) => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.GET_DEGREE, {
            id,
          })}`,
        });
      },
      [request],
    ),

    fetchCreate: useCallback(
      async (data) => {
        return request({
          data,
          method: "POST",
          url: ApiRoutes.CREATE_DEGREE,
        });
      },
      [request],
    ),

    fetchUpdate: useCallback(
      async ({ id, ...data }) => {
        return request({
          data,
          method: "PUT",
          url: urlReplacer(ApiRoutes.UPDATE_DEGREE, {
            id,
          }),
        });
      },
      [request],
    ),

    fetchDelete: useCallback(
      async (id) => {
        return request({
          method: "DELETE",
          url: `${urlReplacer(ApiRoutes.DELETE_DEGREE, { id })}`,
        });
      },
      [request],
    ),
  };
}
